import { NetworkManager, post } from '@tencent/pmd-network';

export type GeneralRequest = <TReq, TResp>(cmd: string, payload: TReq, options?: any) => Promise<TResp>;
export type ErrorException = { r?: number, msg?: string, [key: string]: any, };
export type PowerPartial<T> = { [U in keyof T]?: T[U] extends object ? PowerPartial<T[U]> : T[U] };

export const initPost = function (url: string) {
  return <TReq, TResp>(cmd: string, payload: TReq, options?: any): Promise <TResp> =>  NetworkManager.instance.request({
    url: url + cmd,
    reqData: payload,
    ...options,
  });
};

export class GeneralClass {
  generalRequestMethod: GeneralRequest;
  addressName: string;

  constructor(generalRequestMethod: any, addressName: string) {
    this.generalRequestMethod = generalRequestMethod as GeneralRequest;
    this.addressName = addressName;
  }

  public setUrl(url: string) {
    this.generalRequestMethod = initPost(url);
  }

  public setDomain(domain: string) {
    const url = `https://${domain}${this.addressName}`;
    this.generalRequestMethod = initPost(url);
  }
}


export const goMock = ({
  methodName,
  addressName,
  payload,
  options,
  resolve,
  reject,
}) => {
  if (options?.extra?.withCredentials) {
    options.extra.withCredentials = false;
  }
  post({
    url: `https://mobile.woa.com/rd-platform-cgi/mock${addressName}${methodName}`,
    reqData: payload,
    ...options,
    extra: {
      withCredentials: false,
    },
  }).then((response) => {
    resolve([response]);
  })
    .catch((error) => {
      if (options?.alwaysResolve) {
        resolve([{}, error]);
      } else {
        reject(error);
      }
    });
};
